import React from 'react';
import PropTypes from 'prop-types';

const IconReset = ({ className }) => (
  <svg
    className={className}
    height="24"
    preserveAspectRatio="xMidYMid"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#refresh_clip0)">
      <path d="M10.8803 -6.08475e-05C10.9939 -0.000234689 11.0668 0.12043 11.0135 0.220324L7.15162 7.46004C7.09684 7.56273 6.95057 7.56643 6.89026 7.46665L5.2476 4.74904C3.3255 6.36294 2.0772 8.75571 2.00218 11.4547C1.88511 15.6666 4.6625 19.2912 8.53796 20.4307C9.06765 20.5865 9.3703 21.1405 9.21394 21.6681C9.05759 22.1957 8.50144 22.4972 7.97175 22.3414C3.24816 20.9525 -0.139855 16.537 0.00294616 11.3995C0.0976061 7.99401 1.72376 4.99084 4.20545 3.02489L2.52185 0.239546C2.46154 0.13977 2.53326 0.0127309 2.65 0.012552L10.8803 -6.08475e-05Z" />
      <path d="M14.5072 1.73094C14.6489 1.1992 15.1964 0.882516 15.7302 1.0236C20.4906 2.28174 24 6.60218 24 11.7416C24 15.6586 21.9615 19.0998 18.8846 21.0722L20.5095 23.7603C20.5698 23.8601 20.4981 23.9871 20.3813 23.9873L12.151 23.9999C12.0374 24.0001 11.9645 23.8794 12.0178 23.7796L15.8797 16.5398C15.9345 16.4371 16.0808 16.4335 16.1411 16.5332L17.8526 19.3647C20.35 17.7411 22 14.9325 22 11.7416C22 7.52812 19.123 3.98143 15.2173 2.94919C14.6835 2.8081 14.3656 2.26267 14.5072 1.73094Z" />
    </g>
    <defs>
      <clipPath id="refresh_clip0">
        <rect
          height="24"
          width="24"
        />
      </clipPath>
    </defs>
  </svg>
);

IconReset.propTypes = {
  className: PropTypes.string,
};

IconReset.defaultProps = {
  className: '',
};

export default IconReset;
